module.exports = __webpack_public_path__ + "files/f4c654981f39dde03c806088b107cebe.png";